<script setup>
  import { storeToRefs } from "pinia";
  import { Trash } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { Switch } from "@/components/ui/switch";
  import { ConfirmDialog } from "@/components/episto-ui/confirm-dialog";
  import ListContainer from "@/components/episto-ui/list/ListContainer.vue";
  import ListItem from "@/components/episto-ui/list/ListItem.vue";
  import { useMAudiencesStore } from "@stores/mAudiences";

  const audiencesStore = useMAudiencesStore();
  const { getMAudiences } = storeToRefs(audiencesStore);
  const {
    selectAudience,
    duplicateAudience,
    removeAudience,
    addAudience,
    isAudienceSelected,
    updateAudienceStatus,
    isNewAudience,
    isRemovableAudience,
  } = audiencesStore;
</script>

<template>
  <ListContainer
    :add-element="addAudience"
    element-name="audience"
    :show-header="false">
    <template #elements>
      <ListItem
        v-for="(audience, index) in getMAudiences"
        :key="audience.id"
        :index="index"
        :element-title="audience.name"
        :select-element="selectAudience"
        :duplicate-element="duplicateAudience"
        :is-element-selected="isAudienceSelected">
        <template #actions>
          <ConfirmDialog
            v-if="isRemovableAudience(audience)"
            title="Delete audience"
            description="Are you sure you want to delete this audience?"
            confirm-label="Delete"
            @confirm="removeAudience(index)">
            <template #trigger>
              <Button
                variant="ghost"
                size="icon-sm">
                <Trash class="h-4 w-4" />
              </Button>
            </template>
          </ConfirmDialog>
          <Switch
            v-if="!isNewAudience(audience)"
            size="sm"
            :model-value="audience.status === 'active'"
            @update:model-value="updateAudienceStatus(index, $event ? 'active' : 'inactive')" />
        </template>
      </ListItem>
    </template>
  </ListContainer>
</template>
